import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
const reviews = [{
  id: 1,
  title: 'Innovative Care for Brilliant Smiles',
  text: "Me & my family have been coming here for years. I've never felt more comfortable anywhere else then Colesville Dental Center. I recommend them to everyone I know. They're the best!",
  author: 'Mr. Edmond Thomas',
  image: 'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&q=80&w=800'
}, {
  id: 2,
  title: 'Professional and Friendly Staff',
  text: 'The team here is amazing. They explained everything clearly and made sure I was comfortable throughout my entire procedure. My smile has never looked better!',
  author: 'Sarah Jenkins',
  image: 'https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&q=80&w=800'
}, {
  id: 3,
  title: 'Exceptional Dental Experience',
  text: "From the moment I walked in, I felt welcomed. The technology they use is top-notch, and the results speak for themselves. I'm so glad I found this clinic.",
  author: 'Michael Chen',
  image: 'https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?auto=format&fit=crop&q=80&w=800'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 500 : -500,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 500 : -500,
      opacity: 0
    })
  };
  const swipeConfidenceThreshold = 10000;
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
  };
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setCurrentIndex(prevIndex => (prevIndex + newDirection + reviews.length) % reviews.length);
  };
  return <section id="patient-reviews" className="py-24 bg-[#F8FAFC] overflow-hidden relative" data-id="element-293">
      <div className="max-w-7xl mx-auto px-4 relative" data-id="element-294">
        {/* Navigation Arrows */}
        <div className="absolute top-1/2 -translate-y-1/2 left-4 right-4 flex justify-between items-center z-20 pointer-events-none" data-id="element-295">
          <button onClick={() => paginate(-1)} className="p-2 text-slate-300 hover:text-[#54c595] transition-colors pointer-events-auto" data-id="element-296">
            <ChevronLeft size={40} strokeWidth={1} data-id="element-297" />
          </button>
          <button onClick={() => paginate(1)} className="p-2 text-slate-300 hover:text-[#54c595] transition-colors pointer-events-auto" data-id="element-298">
            <ChevronRight size={40} strokeWidth={1} data-id="element-299" />
          </button>
        </div>

        <div className="relative min-h-[500px] flex items-center" data-id="element-300">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-301">
            <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.2
            }
          }} className="w-full grid lg:grid-cols-2 gap-12 items-center" data-id="element-302">
              {/* Left Content */}
              <div className="space-y-8" data-id="element-303">
                <div className="flex items-center gap-3" data-id="element-304">
                  <div className="flex items-center bg-[#54c595] text-white px-4 py-1.5 rounded-full gap-2 shadow-sm" data-id="element-305">
                    <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center" data-id="element-306">
                      <Star size={14} fill="white" data-id="element-307" />
                    </div>
                    <span className="text-[11px] font-bold uppercase tracking-widest" data-id="element-308">
                      Reviews
                    </span>
                  </div>
                </div>

                <h2 className="text-4xl md:text-5xl font-bold text-[#4bafbc] leading-tight" data-id="element-309">
                  {reviews[currentIndex].title}
                </h2>

                <p className="text-lg text-slate-600 leading-relaxed max-w-xl" data-id="element-310">
                  {reviews[currentIndex].text}
                </p>

                <div className="pt-4" data-id="element-311">
                  <p className="text-xl font-bold text-[#4bafbc]" data-id="element-312">
                    {reviews[currentIndex].author}
                  </p>
                </div>
              </div>

              {/* Right Image */}
              <div className="relative" data-id="element-313">
                <div className="relative rounded-bl-[100px] rounded-tr-[100px] overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-314">
                  <img src={reviews[currentIndex].image} alt="Patient Care" className="w-full h-full object-cover" data-id="element-315" />
                </div>

                {/* Cute Tooth Illustration Placeholder */}
                <div className="absolute -bottom-12 -right-8 w-32 h-32 z-10" data-id="element-316">
                  <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-lg" data-id="element-317">
                    <circle cx="50" cy="50" r="45" fill="#cef4d2" data-id="element-318" />
                    <path d="M30 40 Q30 20 50 20 Q70 20 70 40 Q70 60 50 80 Q30 60 30 40" fill="white" data-id="element-319" />
                    <circle cx="40" cy="40" r="3" fill="#225274" data-id="element-320" />
                    <circle cx="60" cy="40" r="3" fill="#225274" data-id="element-321" />
                    <path d="M40 55 Q50 65 60 55" stroke="#225274" strokeWidth="2" fill="none" strokeLinecap="round" data-id="element-322" />
                    <path d="M80 20 L85 25 M85 20 L80 25" stroke="#54c595" strokeWidth="2" data-id="element-323" />
                    <path d="M15 75 L20 80 M20 75 L15 80" stroke="#54c595" strokeWidth="2" data-id="element-324" />
                  </svg>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-12" data-id="element-325">
          {reviews.map((_, idx) => <button key={idx} onClick={() => {
          setDirection(idx > currentIndex ? 1 : -1);
          setCurrentIndex(idx);
        }} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${currentIndex === idx ? 'bg-[#54c595] w-8' : 'bg-slate-200 hover:bg-slate-300'}`} data-id="element-326" />)}
        </div>
      </div>
    </section>;
}